import { AbstractAccountDataCommand } from "./abstractAccountDataCommand";

export class LogoutCommand extends AbstractAccountDataCommand {
  allSessions?: boolean;
}